import React, {useContext, useEffect, useState} from "react";
import {Modal, ScrollView, View} from "react-native";
import MainStyle from "../../MainStyle";
import ServiceClient from "../utils/ServiceClient";
import {StoreContext} from "../components/StoreContextProvider";
import {Promo} from "../../generated/smg_service_pb";
import {NativeStackNavigationProp} from "@react-navigation/native-stack";
import {useNavigation} from "@react-navigation/native";
import Div from "../lib/Div";
import Loader from "../components/Loader";
import PromoCard from "../screens/User/promos/components/PromoCard";
import ModalHeaderFS from "../components/ModalHeaderFS";
import CancelModal from "../screens/Auth/SignUp/steps/CancelModal";
import {CancelModalProps} from "../types";

type Props = { visible: boolean, onClose: () => void };

const AllPromosModal = (props: Props) => {
  const {visible} = props;
  const Context = useContext(StoreContext);
  const [promos, setPromos] = useState<Promo[]>([]);
  const {user} = Context;
  const navigation: NativeStackNavigationProp<any> = useNavigation();
  const [loadingOverlay, setLoadingOverlay] = useState(false);
  const [cancelModalConfig, setCancelModalConfig] = useState<CancelModalProps>({visible: false, title: '', subtitle: ''});

  const getPromos = (userId: number) => {
    setLoadingOverlay(true);

    ServiceClient.getPromos(userId).then(res => {
      setLoadingOverlay(false);
      setPromos(res);

    }).catch(err => {
      setLoadingOverlay(false);
      setCancelModalConfig({
        visible: true, subtitle: err.message || 'Request Promos Error', title: 'Error', leftBtnText: 'OK',
        onExit: () => {
          setCancelModalConfig({...cancelModalConfig, visible: false});
          navigation.navigate({name: 'account', params: {step: 1}});
        }
      });
    });
  };

  useEffect(() => {
    if (visible && typeof user?.userId !== 'undefined') getPromos(Number(user.userId));
  }, [visible]);

  return (
    <Modal animationType="fade" transparent visible={visible} statusBarTranslucent={false} hardwareAccelerated={false}
           onRequestClose={props.onClose}>
      <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
        <ModalHeaderFS title="All Promos" px={20} onCancel={props.onClose}/>

        <ScrollView style={[MainStyle.flex1, {backgroundColor: '#131314'}]} contentContainerStyle={{flexGrow: 1}}>
          <Div alignItems="center">
            {promos.map((promo, i) => (
              <PromoCard key={promo.id.toString() + i} data={promo}/>
            ))}
          </Div>
        </ScrollView>
      </View>

      <Loader visible={loadingOverlay}/>
      <CancelModal config={cancelModalConfig}/>
    </Modal>
  );
};

export default AllPromosModal;
